// extracted by mini-css-extract-plugin
module.exports = {"root":"Tabs_root__1xng9","tab":"Tabs_tab__2ymFx","tabActive":"Tabs_tabActive__1UbVV"};